import api from './api';

export interface ValidadeHistoricoItem {
  id: string;
  produto_id: string;
  dias_validade_anterior: number | null;
  dias_validade_novo: number | null;
  justificativa: string | null;
  responsavel_nome?: string | null;
  estoque_existente?: number | null;
  data_alteracao: string;
}

const validadeHistoricoService = {
  async porProduto(produtoId: string): Promise<ValidadeHistoricoItem[]> {
    const response = await api.get<ValidadeHistoricoItem[]>('/industrializacao/validade-historico/por_produto', {
      params: { produto_id: produtoId },
    });
    return response.data;
  },
};

export default validadeHistoricoService;
